import omit from 'lodash/omit'

// TODO: утилита является временным решением
// В дальнейшем необходимо будет
// А) передавать пропсы напрямую, не прокидывая их через атрибуты
// возможны варианты, как с несколькими пропсами под каждое значение,
// так и с одним общим пропсом (типа inputAttrs)
// Б) пересмотреть верстку так, чтобы избавиться от необходимости передачи атрибутов,
// сделав тег/компонент, которому передавались атрибуты, рутовым (если такое возможно)
// В) извлекать наследуемые потомком атрибуты с помощью lodash/pick или lodash/omit
/**
 * Принимает атрибуты компонента и возвращает их же, но уже без стилей и классов
 *
 * Иначе говоря, приводит атрибуты к состоянию, как во Vue 2,
 * в котором поля class и style не входят в состав атрибутов
 *
 * Breaking changes: https://v3-migration.vuejs.org/breaking-changes/attrs-includes-class-style.html
 *
 * @param {object} $attrs исходные атрибуты компонента
 */
export const getAttrsAsInVue2 = ($attrs) => {
  return omit($attrs, ['class', 'style'])
}
